import React from 'react'
import type { IMAGE_DETAIL_TAB } from './infoView'
import type { TCurrentImageInfo, IQueryParams } from './interface'

type TChangeData = {
    entityId: string,
    inspirationId: string,
    price:number,
    styleDesc:string,
    styleTitle: string,
    tagNameList: any[],
    imageEntityExtend: any;
    imageGroupEntityId: string,
}

export interface IImageDetailContext<T = any> { // T 代补充
    runImgsData?: ()=>void,
    currentImage: TCurrentImageInfo,
    tabValue: IMAGE_DETAIL_TAB,
    onTabChange: (val:IMAGE_DETAIL_TAB)=>void,
    queryParams: IQueryParams,
    onInit: ()=>void,
    initWaterfall: ()=>void,
    onVisibleChange:T,
    onChange: (success:boolean, newItemData: TChangeData)=>void,
    setBanOperation:T,
    boxIndex:T,
    setBoxIndex:T,
    upgradeInfo:T,
    reload:T,
    onDeleteItem: ()=>void,
    tags:T,
    samples:T,
    commentTotal:T,
    onInitCommentTotal: T,
    notes:T,
    setNotes:T,
    onInitNotes:T,
    isMove:T,
    setIsMove:T,
    activeNoteIndex:T,
    setActiveNoteIndex:T,
    isAnnotate:T,
    setIsAnnotate:T,
    showRight:T,
    setShowRight:T,
    isPage:T,
}

export const ImageDetailContext:IImageDetailContext | any = React.createContext({})
